import RoutePoint from './RoutePoints';

export default RoutePoint;
